export default __webpack_public_path__ + "48861d924ba40355432d9209450f11d0.woff";